import { gql } from "@apollo/client"

export const MUTATION_DELETE_THEME_INTEREST = gql`
  mutation DeleteThemeOfInterest($themeOfInterestId: String!) {
    deleteThemeOfInterest(themeOfInterestId: $themeOfInterestId) {
      message
      data {
        id
      }
    }
  }
`
